/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Rolemember2Inputs */

const zh_organizationsettings_rolemember2 = /** @type {(inputs: Organizationsettings_Rolemember2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成员`)
};

const en_organizationsettings_rolemember2 = /** @type {(inputs: Organizationsettings_Rolemember2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member`)
};

const es_organizationsettings_rolemember2 = /** @type {(inputs: Organizationsettings_Rolemember2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembro`)
};

/**
* | output |
* | --- |
* | "Member" |
*
* @param {Organizationsettings_Rolemember2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_rolemember2 = /** @type {((inputs?: Organizationsettings_Rolemember2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Rolemember2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_rolemember2(inputs)
	if (locale === "en") return en_organizationsettings_rolemember2(inputs)
	return es_organizationsettings_rolemember2(inputs)
});
export { organizationsettings_rolemember2 as "organizationSettings_roleMember" }